// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.eventlogger

import org.multipaz.cbor.DataItem
import org.multipaz.eventlogger.EventProvisioningIssuerDataOpenID4VCI
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.provisioning.Display
import org.multipaz.cbor.Tstr
import org.multipaz.provisioning.toDataItem
import org.multipaz.provisioning.fromDataItem

fun EventProvisioningIssuerDataOpenID4VCI.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "4VRlqv42dEEm7GBsl3LXrc89RaB2hKoWIvUxFc25vYY")
val EventProvisioningIssuerDataOpenID4VCI_cborSchemaId = ByteString(-31, 84, 101, -86, -2, 54, 116, 65, 38, -20, 96, 108, -105, 114, -41, -83, -49, 61, 69, -96, 118, -124, -86, 22, 34, -11, 49, 21, -51, -71, -67, -122)

fun EventProvisioningIssuerDataOpenID4VCI.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("type", "OpenID4VCI")
    builder.put("display", this.display.toDataItem())
    builder.put("url", Tstr(this.url))
    builder.put("credentialId", Tstr(this.credentialId))
    return builder.end().build()
}

fun EventProvisioningIssuerDataOpenID4VCI_fromDataItem(dataItem: DataItem): EventProvisioningIssuerDataOpenID4VCI {
    val display = Display.fromDataItem(dataItem["display"])
    val url = dataItem["url"].asTstr
    val credentialId = dataItem["credentialId"].asTstr
    return EventProvisioningIssuerDataOpenID4VCI(
        display = display,
        url = url,
        credentialId = credentialId,
    )
}
